<div class="mitre-container">
  <shared-mitre-info
    [tactics]="pkg()?.mapping?.mitre?.mitre_attack_tactics ?? []"
    [techniques]="pkg()?.mapping?.mitre?.mitre_attack_techniques ?? []"
    [techniqueIds]="pkg()?.mapping?.mitre?.mitre_attack_technique_ids ?? []"
  ></shared-mitre-info>
</div>
